<section class="container-fluid position-relative">
  <div class="container sticky-top">
    <div class="row justify-content-center">
      <div class="col-md-9 mb-4">
        <app-callidus-stepper
          [setCurrentPosition]="getCurrentPosition()"
          [stepItems]="getStepItems()"></app-callidus-stepper>
      </div>
    </div>
  </div>

  @switch (curentNavigationStep) {
    @case (SkipperHaftpflichtNavigationEnum.Base) {
      <app-skipper-general
        (next)="moveToNextStep()"
        (prev)="moveToPreviousStep()"
        [form]="form">
      </app-skipper-general>
    }
    @case (SkipperHaftpflichtNavigationEnum.SkipperHaftpflichtDetails) {
      <app-skipper-haftpflicht-details
        (prev)="moveToPreviousStep()"
        (next)="moveToNextStep()"
        [form]="form"></app-skipper-haftpflicht-details>
    }
    @case (SkipperHaftpflichtNavigationEnum.SkipperRechtsschutzDetails) {
      <app-skipper-rechtsschutz-details
        (prev)="moveToPreviousStep()"
        (next)="moveToNextStep()"
        [form]="form"></app-skipper-rechtsschutz-details>
    }
    @case (SkipperHaftpflichtNavigationEnum.Customer) {
      <app-customer-data
        (prev)="moveToPreviousStep()"
        (submitted)="submitData()"
        [form]="form.controls.customerData"></app-customer-data>
    }
    @case (SkipperHaftpflichtNavigationEnum.Done) {
      <app-data-submitted></app-data-submitted>
    }
  }
</section>
